import React, { useEffect, useState } from "react";
import { fetchFormData } from "./options";
import topTost from "./topTost";
import { ImageUrl } from "..";

import SelectDropdown from "../Components/shared/SelectDropdown";
import Swal from "sweetalert2";

const ShowRenewalStatus = ({
  show,
  onClose,
  selectedId,
  currentStatus,
  onStatusChange,
  student,
}) => {
  const [packages, setPackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState("");
  const [changePackage, setChangePackage] = useState(false);

  useEffect(() => {
    if (show && student) {
      listPackage();
      setSelectedPackage(student.package_id);
    }
  }, [show]);
  if (!selectedId) {
    return null;
  }
  const handleStatusUpdate = async (statusValue) => {
    let actionText = statusValue === 2 ? "Approve" : "Reject";
    const result = await Swal.fire({
      title: `Are you sure you want to ${actionText} this Subscription`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });
    if (!result.isConfirmed) return;
    try {
      const formData = new FormData();
      formData.append("student_id", selectedId);
      formData.append("subscription_status", statusValue);

      const response = await fetchFormData(
        "student-subscription-update",
        formData,
        "POST"
      );

      if (response?.code === 200 || response?.code === 201) {
        topTost({
          title: "Status updated successfully!",
          icon: "success",
        });

        if (typeof onStatusChange === "function") {
          onStatusChange(response.data.id, response.data.status);
        }
        onClose();
        setTimeout(() => window.location.reload(), 600);
      } else {
        topTost({
          title: response?.message || "Update failed!",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("API error:", error);
      topTost({
        title: "Something went wrong!",
        icon: "error",
      });
    }
  };
  const updatePackage = async () => {
    try {
      const formData = new FormData();
      formData.append("package_id", selectedPackage);
      formData.append("payout_id", student.id);
      const response = await fetchFormData(
        "update-payout-package",
        formData,
        "POST"
      );
      if (response?.code === 200) {
        topTost({
          title: response?.message,
          icon: "success",
        });
        onClose();
        setTimeout(() => window.location.reload(), 1000);
      } else {
        topTost({
          title: response?.message || "Update failed!",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("API error:", error);
      topTost({
        title: "Something went wrong!",
        icon: "error",
      });
    }
  };
  const listPackage = async () => {
    try {
      const result = await fetchFormData("package-dropdown", {}, "POST");
      if (result?.code === 200) {
        setPackages(
          result.data.map((item) => ({
            label: item.package_name,
            value: item.id,
          }))
        );
      }
    } catch (error) {
      console.error("API error:", error);
      topTost({
        title: "Something went wrong!",
        icon: "error",
      });
    }
  };

  const getStatus = (status) => {
    const s = Number(status);

    switch (s) {
      case 0:
        return { text: "Pending", className: "text-warning fw-bold" };
      // case 1:
      //   return { text: "Admin Approval Required", className: "text-warning fw-bold" };
      case 1:
        return { text: "Approved", className: "text-primary fw-bold" };
      // case 3:
      //   return { text: "Rejected", className: "text-danger fw-bold" };
      // case 4:
      //   return { text: "Expired", className: "text-black fw-bold" };
     default:
      return { text: "Unknown Status", className: "text-secondary fw-bold" };
    }
  };

  const current = getStatus(currentStatus);
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };
  return (
    <div
      className={`modal ${show ? "show d-block" : "d-none"}`}
      style={{ background: "rgba(0,0,0,0.4)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content fw-bold">
          <div className="modal-header ">
            <div>
              <h5 className="modal-title">Name: {student.name}</h5>
              <h5 className="modal-title"> Mobile Number: {student.phone}</h5>
              {student.subscription_end_date && (
                <h5 className="modal-title">
                  {" "}
                  Last Subs. End Date :{" "}
                  {formatDate(student.subscription_end_date)}
                </h5>
              )}
            </div>

            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          {/* Receipt section */}
          {student && (
            <div className="row mt-3 px-4">
              {/* LEFT SIDE – Receipt */}
              <div className="col-md-6">
                <h6>Payment Receipt:</h6>

                <div
                  className="border rounded p-2 d-flex flex-column align-items-center"
                  style={{ width: "150px" }}
                >
                  <img
                    src={`${ImageUrl}${student.payment_receipt}`}
                    alt="receipt"
                    className="img-fluid mb-2"
                    style={{ maxHeight: "70px", objectFit: "contain" }}
                  />

                  <small className="text-muted text-truncate w-100 text-center">
                    {student?.payment_receipt || ""}
                  </small>

                  <a
                    href={`${ImageUrl}${student.payment_receipt}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-primary btn-sm w-100 mt-1"
                  >
                    VIEW
                  </a>
                </div>
              </div>

              {/* RIGHT SIDE – Change Package */}
              <div className="col-md-6">
                <div className="form-check mb-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={changePackage}
                    onChange={(e) => setChangePackage(e.target.checked)}
                  />
                  <label className="form-check-label">
                    Change Package?
                  </label>
                </div>

                {changePackage && (
                  <div className="mb-3 text-start">
                    <label className="form-label">Select Package</label>

                    <SelectDropdown
                      id="package-select"
                      name="package_id"
                      value={selectedPackage}
                      options={packages}
                      placeholder="Select Package"
                      onSelectOption={(option) =>
                        setSelectedPackage(option.value)
                      }
                    />
                  </div>
                )}
              </div>
            </div>
          )}

          <div className="card mb-4 ">
            <div className="card-body">
              <div className="row ">
                <div className="col-md-6 mb-2">
                  <strong>Package: </strong> {student?.package_name || ""}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Validity:</strong> {student?.validity_period || ""}{" "}
                  days
                </div>
                <div className="col-md-6 mb-2">
                  <strong>UTR Number:</strong> {student?.utr_number || ""}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Amount:</strong> ₹{student?.amount || ""}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Subs. Start Date:</strong>{" "}
                  {formatDate(student?.activate_date) || ""}
                </div>

                <div className="col-md-6 mb-2">
                  <strong>Subs. End Date:</strong>{" "}
                  {formatDate(student?.deactivate_date) || ""}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-body text-center">
            {/*  Current Status Line */}
            <div className="mb-3 p-2 border rounded bg-light">
              Subscription Status:{" "}
              <span className={current.className}>{current.text}</span>
            </div>
            {Number(currentStatus) === 0 && (
              <div className="d-flex flex-wrap gap-2">
                <button
                  className="btn btn-success flex-fill"
                  onClick={() => handleStatusUpdate(2)}
                >
                  Approved
                </button>

                <button
                  className="btn btn-danger flex-fill"
                  onClick={() => handleStatusUpdate(3)}
                >
                  Rejected
                </button>
              </div>
            )}
          </div>

          <div className="modal-footer">
            <button className="btn btn-danger" onClick={onClose}>
              Close
            </button>
            {changePackage && (
              <button
                className="btn btn-primary"
                onClick={updatePackage}
                disabled={!selectedPackage}
              >
                Update
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowRenewalStatus;
